module.exports = __webpack_public_path__ + "static/img/concept_page3.6ed4b1c1.jpg";